import { Button, ButtonProps } from '@mui/material'
import React from 'react'

export const BaseButton: React.FC<ButtonProps> = ({ children, ...rest }) => {
  return <Button {...rest}>{children}</Button>
}
